<template>
  <form ref="form" @submit.prevent="validateForm">
    <input
      placeholder="Chain Name"
      type="text"
      v-model="node.chainName"
      class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]"
    />
    <span v-if="errors.chainName" class="text-red text-sm block text-left">{{ errors.chainName }}</span>
    <input
      placeholder="Number of Decimals"
      type="number"
      v-model="node.decimalsCount"
      class="w-full border border-[#E2E8F0] rounded-[8px] py-[10px] px-[12px] mt-[20px]"
    />
    <span v-if="errors.decimalsCount" class="text-red text-sm block text-left">{{ errors.decimalsCount }}</span>
    <button
      type="submit"
      ref="updateNodeButton"
      class="flex gap-[5px] items-center block mx-auto justify-center hover:!bg-[#000000] my-[40px] focus:!bg-[#000000] capitalize !bg-blue-light text-white !min-h-[50px] !max-h-[60px] !w-[120px] button text-white font-montserrat-bold bg-blue-light text-[16px] font-bold rounded-[10px]"
    >
      Update
    </button>
  </form>
</template>

<script>
export default {
  name: 'NodeUpdateForm',
  props: {
    mode: {
      type: String,
      required: true,
      default: 'create', // 'create' or 'update'
    },
    nodeObj: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    nodeObj: {
      handler(newVal) {
        this.node = { ...newVal };
      },
      immediate: true,
    },
  },
  data() {
    return {
      node: this.nodeObj,
      errors: {
        ip: '',
        port: '',
        chainName: '',
        decimalsCount: '',
      },
    };
  },
  methods: {
   resetForm() {
      // Reset form data
      this.node = {
        chainName: '',
        decimalsCount: ''
      };
      
      // Reset errors
      this.errors = {
        chainName: '',
        decimalsCount: ''
      };

      // defocus the button after submission
      this.$refs.updateNodeButton.blur(); 

    },
    validateForm() {
      // Reset errors
      this.errors = {
        chainName: '',
        decimalsCount: ''
      };

      // Validate inputs
      if (!this.node.chainName) {
        this.errors.chainName = 'Chain name is required.';
      }
      if (!this.node.decimalsCount) {
        this.errors.decimalsCount = 'Number of decimals is required.';
      }

      // If there are no errors, proceed with adding the node
      if (Object.values(this.errors).every(error => !error)) {
        this.$emit('onSubmit', this.node);
        this.resetForm();
      }
    },
  }
};
</script>
